document.addEventListener("DOMContentLoaded", () => {

    const overlay = document.querySelector('.loading-moldura');
    if (overlay) {
        window.addEventListener('load', () => {
            setTimeout(() => {
                overlay.remove();
            }, 1500);
        });
    }

    // Pré-carregamento de imagens
    const molduraTipos = ["horizontal", "quadrado", "vertical"];
    const tiposBase = ["padrao", "canvas", "caixa", "padrao-com-paspatur"];
    const coresMoldura = ["preta", "branca", "pinus", "mel"];
    const imageFiles = [];
    molduraTipos.forEach(moldura => {
        tiposBase.forEach(tipo => {
            coresMoldura.forEach(cor => {
                imageFiles.push(`${moldura}-${tipo}-${cor}.webp`);
            });
        });
    });
    const baseUrl = "https://obrah.com.br/cdn/shop/files/";
    function preloadImages() {
        imageFiles.forEach(fileName => {
            if (!document.querySelector(`link[href="${baseUrl + fileName}"]`)) {
                const linkElement = document.createElement("link");
                linkElement.rel = "preload";
                linkElement.href = baseUrl + fileName;
                linkElement.as = "image";
                document.head.appendChild(linkElement);
            }
        });
    }
    preloadImages();

    
    // Organização dos grupos de rádio
    const optimizeRadioGroups = () => {
        const option2 = document.querySelector('[data-index="option1"]');
        if (!option2) return;
        const container = option2.querySelector("div[style*='display: flex']");
        if (!container) return;

        const groups = {
            "Sem vidro": ["canvas"],
            "Com vidro": ["padrão", "padrão com paspatur", "caixa"],
            "Impressão": ["sem moldura"]
        };

        const fragment = document.createDocumentFragment();
        const newContainer = document.createElement("div");
        newContainer.classList.add("radio-groups");

        const inputs = Array.from(container.querySelectorAll("input")).reduce((acc, input) => {
            acc[input.value] = input;
            return acc;
        }, {});

        Object.entries(groups).forEach(([title, values]) => {
            // Verifica se existe pelo menos um input disponível para este grupo
            const availableInputs = values.filter(value => inputs[value]);
            
            // Só cria o grupo se houver pelo menos um input disponível
            if (availableInputs.length === 0) return;

            const groupWrapper = document.createElement("div");
            groupWrapper.classList.add("radio-group");

            const titleElement = document.createElement("div");
            titleElement.textContent = title;
            titleElement.classList.add("group-title");
            groupWrapper.appendChild(titleElement);

            const itemsWrapper = document.createElement("div");
            itemsWrapper.classList.add("radio-items");

            // Usa apenas os inputs disponíveis
            availableInputs.forEach(value => {
                const input = inputs[value];
                const label = input.nextElementSibling;
                if (!label) return;

                const itemWrapper = document.createElement("div");
                itemWrapper.classList.add("radio-item");
                itemWrapper.append(input, label);
                itemsWrapper.appendChild(itemWrapper);
            });

            groupWrapper.appendChild(itemsWrapper);
            fragment.appendChild(groupWrapper);
        });

        newContainer.appendChild(fragment);
        container.replaceWith(newContainer);
    };

    // Configuração inicial
    const setupInitialState = () => {
        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return;

        // Set default moldura type to "canvas"
        const canvasInput = variantSelects.querySelector('[data-handle="escolha-o-tipo-de-moldura"] input[value="canvas"]');
        if (canvasInput && !canvasInput.checked) {
            canvasInput.checked = true;
            canvasInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Set default moldura color to "preta"
        const pretaInput = variantSelects.querySelector('[data-handle="escolha-a-cor-da-moldura"] input[value="mel"]');
        if (pretaInput && !pretaInput.checked) {
            pretaInput.checked = true;
            pretaInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Set default size to the first available size option
        const tamanhoFieldset = variantSelects.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
        if (tamanhoFieldset) {
            const firstTamanhoInput = tamanhoFieldset.querySelector('input');
            if (firstTamanhoInput && !tamanhoFieldset.querySelector('input:checked')) {
                firstTamanhoInput.checked = true;
                firstTamanhoInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        // Ensure "sem moldura" in color is not selected initially
        const semMolduraCorInput = variantSelects.querySelector('[data-handle="escolha-a-cor-da-moldura"] input[value="sem moldura"]');
        if (semMolduraCorInput?.checked && pretaInput) {
            semMolduraCorInput.checked = false;
            pretaInput.checked = true;
            pretaInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };

    // Função para gerenciar a exibição dos destaques com efeito de fade
    const updateDestaques = () => {
        const tipoMolduraFieldset = document.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
        const selectedTipoMoldura = tipoMolduraFieldset?.querySelector('input:checked');
        if (!selectedTipoMoldura) return;

        // Mapeamento explícito para garantir correspondência
        const handleMap = {
            'padrão': 'padrao',
            'padrão com paspatur': 'padrao-com-paspatur',
            'caixa': 'caixa',
            'canvas': 'canvas',
            'sem moldura': 'sem-moldura'
        };

        // Normalizar o valor do tipo de moldura
        const rawValue = selectedTipoMoldura.value.toLowerCase();
        const tipoMolduraValue = handleMap[rawValue] || rawValue
            .replace(/[^a-zA-Z0-9\s-]/g, '')
            .replace(/\s+/g, '-');

        // Selecionar todos os elementos de destaque
        const destaques = document.querySelectorAll('[class*="destaque__"]');
        destaques.forEach(destaque => {
            if (destaque.classList.contains(`destaque__${tipoMolduraValue}`)) {
                destaque.classList.add('destaque--visible');
                destaque.classList.remove('destaque--hidden');
            } else {
                destaque.classList.add('destaque--hidden');
                destaque.classList.remove('destaque--visible');
            }
        });
    };

    // Lógica principal
    const tipoMolduraFieldset = document.querySelector('[data-handle="escolha-o-tipo-de-moldura"]');
    const corMolduraFieldset = document.querySelector('[data-handle="escolha-a-cor-da-moldura"]');
    const tamanhoFieldset = document.querySelector('[data-handle="escolha-o-tamanho-(cm)"]');
    const tamanhoMolduraSlide = document.querySelector('.tamanho_moldura');
    const variantSelects = document.querySelector('variant-selects');

    const updateProductMediaClass = () => {
        const productMedia = document.querySelector('.product-single__media');
        const tamanhoMoldura = document.querySelector('.tamanho_moldura');
        const selectedTipoMoldura = tipoMolduraFieldset?.querySelector('input:checked');
        const selectedCorMoldura = corMolduraFieldset?.querySelector('input:checked');
    
        // Update productMedia classes
        if (productMedia) {
            productMedia.className = 'product-single__media';
            if (selectedTipoMoldura) {
                const tipoMolduraValue = selectedTipoMoldura.value.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').toLowerCase();
                productMedia.classList.add(`escolha-o-tipo-de-moldura-${tipoMolduraValue}`);
            }
            if (selectedCorMoldura) {
                const corMolduraValue = selectedCorMoldura.value.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').toLowerCase();
                productMedia.classList.add(`escolha-a-cor-da-moldura-${corMolduraValue}`);
            }
        }
    
        // Update tamanho_moldura classes, preserving moldura-* and other non-dynamic classes
        if (tamanhoMoldura) {
            const preservedClasses = Array.from(tamanhoMoldura.classList).filter(cls => 
                !cls.startsWith('tamanho-') && 
                !cls.startsWith('escolha-o-tipo-de-moldura-') && 
                !cls.startsWith('escolha-a-cor-da-moldura-')
            );
            tamanhoMoldura.className = 'tamanho_moldura ' + preservedClasses.join(' ');
            if (selectedTipoMoldura) {
                const tipoMolduraValue = selectedTipoMoldura.value.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').toLowerCase();
                tamanhoMoldura.classList.add(`escolha-o-tipo-de-moldura-${tipoMolduraValue}`);
            }
            if (selectedCorMoldura) {
                const corMolduraValue = selectedCorMoldura.value.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').toLowerCase();
                tamanhoMoldura.classList.add(`escolha-a-cor-da-moldura-${corMolduraValue}`);
            }
        }
    };

    const verificarTipoMoldura = () => {
        const inputTipoMoldura = tipoMolduraFieldset?.querySelector('input:checked');
        const corMolduraInputs = corMolduraFieldset?.querySelectorAll('input');
        const semMolduraCorInput = corMolduraFieldset?.querySelector('input[value="sem moldura"]');

        if (!inputTipoMoldura || !corMolduraInputs || !variantSelects) return;

        if (inputTipoMoldura.value === 'sem moldura') {
            const selectedColor = corMolduraFieldset.querySelector('input:checked:not([value="sem moldura"])');
            if (selectedColor) {
                lastColorBeforeNoFrame = selectedColor.value;
            }

            corMolduraFieldset.classList.add('disable');
            corMolduraInputs.forEach(input => {
                input.disabled = input.value !== 'sem moldura';
            });

            if (semMolduraCorInput && !semMolduraCorInput.checked) {
                semMolduraCorInput.checked = true;
                semMolduraCorInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        } else {
            corMolduraFieldset.classList.remove('disable');
            corMolduraInputs.forEach(input => {
                input.disabled = input.value === 'sem moldura';
            });

            if (semMolduraCorInput?.checked) {
                const colorToRestore = corMolduraFieldset.querySelector(`input[value="${lastColorBeforeNoFrame}"]`);
                if (colorToRestore) {
                    colorToRestore.checked = true;
                    colorToRestore.dispatchEvent(new Event('change', { bubbles: true }));
                } else {
                    const pretaCorInput = corMolduraFieldset?.querySelector('input[value="preta"]');
                    if (pretaCorInput) {
                        pretaCorInput.checked = true;
                        pretaCorInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
        }
        updateProductMediaClass();
        updateDestaques(); // Chama a função para atualizar os destaques
    };

    const updateTamanhoClass = () => {
        const quadroImg = document.querySelector('.tamanho_moldura .quadro');
        const tamanhoMoldura = document.querySelector('.tamanho_moldura');
        let selectedTamanho = tamanhoFieldset?.querySelector('input:checked');

        // If no size is selected, select the first size option
        if (!selectedTamanho && tamanhoFieldset) {
            const firstTamanhoInput = tamanhoFieldset.querySelector('input');
            if (firstTamanhoInput) {
                firstTamanhoInput.checked = true;
                firstTamanhoInput.dispatchEvent(new Event('change', { bubbles: true }));
                selectedTamanho = firstTamanhoInput;
            }
        }

        if (quadroImg) {
            quadroImg.classList.forEach(className => {
                if (className.startsWith('tamanho-')) {
                    quadroImg.classList.remove(className);
                }
            });
            if (selectedTamanho) {
                const tamanhoValue = selectedTamanho.value.replace(/[^a-zA-Z0-9]/g, 'x').toLowerCase();
                quadroImg.classList.add(`tamanho-${tamanhoValue}`);
            }
        }

        if (tamanhoMoldura) {
            tamanhoMoldura.classList.forEach(className => {
                if (className.startsWith('tamanho-')) {
                    tamanhoMoldura.classList.remove(className);
                }
            });
            if (selectedTamanho) {
                const tamanhoValue = selectedTamanho.value.replace(/[^a-zA-Z0-9]/g, 'x').toLowerCase();
                tamanhoMoldura.classList.add(`tamanho-${tamanhoValue}`);
            }
        }
    };

    if (tipoMolduraFieldset) {
        tipoMolduraFieldset.querySelectorAll('input').forEach(input => {
            input.addEventListener('change', () => {
                verificarTipoMoldura();
                updateTamanhoClass(); // Ensure size is updated when moldura type changes
            });
        });
    }

    if (corMolduraFieldset) {
        corMolduraFieldset.querySelectorAll('input').forEach(input => {
            input.addEventListener('change', () => {
                updateProductMediaClass();
                updateTamanhoClass(); // Ensure size is updated when color changes
            });
        });
    }

    if (tamanhoFieldset) {
        tamanhoFieldset.querySelectorAll('input').forEach(input => {
            input.addEventListener('change', () => {
                if (tamanhoMolduraSlide) {
                    tamanhoMolduraSlide.scrollIntoView({ behavior: 'smooth' });
                }
                updateTamanhoClass();
            });
        });
    }

    // Inicialização
    optimizeRadioGroups();
    setupInitialState();
    verificarTipoMoldura();
    updateProductMediaClass();
    updateTamanhoClass();
    updateDestaques(); // Inicializa os destaques
    
});